import { FormattedMessage, trans } from '@lingoda/i18n';
import { WarningIcon } from '@lingoda/ui/icons/lingodaIcons';
import { BannerAlert } from './styled';
import { chromiumLinkValues } from './utils';

interface Props {
    severity?: 'error' | 'warning';
}

export const YourBrowserIsNotSupportedBanner = ({ severity = 'warning' }: Props) => {
    return (
        <BannerAlert
            severity={severity}
            title={trans(
                'your-browser-is-not-supported-banner.title',
                {},
                'classroom-common+intl-icu',
            )}
            variant="outlined"
            icon={<WarningIcon size={24} />}
        >
            <FormattedMessage
                message={trans(
                    'your-browser-is-not-supported-banner.body',
                    {},
                    'classroom-common+intl-icu',
                )}
                values={chromiumLinkValues}
            />
        </BannerAlert>
    );
};
